<template>
  <RegistryDataTable :loading="loading"
                     :registries="registries"
                     :total="total"
                     @update="onUpdate"
  />
</template>

<script>
import RegistryDataTable from '@/components/RegistryDataTable'
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP, LAYOUT_TITLE_CHANGED} from "@/store/modules/layout/actions";
import RegistryService from "@/services/registry.service";
import _ from "underscore";
import Mappers from "@/mappers";

export default {
  name: "RegistriesView",
  components: {
    RegistryDataTable
  },
  data() {
    return {
      loading: false,
      registries: [],
      total: 0
    }
  },
  methods: {
    onUpdate(options) {
      this.reloadRegistries(options)
    },
    reloadRegistries(options) {
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START)

      const {page, itemsPerPage} = options;
      const skip = (page - 1) * itemsPerPage;

      RegistryService.getDataTable({
        skip: skip,
        limit: itemsPerPage,
      })
          .then(response => {
            this.registries = _.map(response.data.Records, registryViewModel => {
              return Mappers.mapRegistry(registryViewModel)
            })
            this.total = response.data.Total;
          }, () => {

          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    }
  },
  created() {
    this.$store.dispatch(LAYOUT_TITLE_CHANGED, 'Список импортированных реестров')
  }
}
</script>

<style scoped>

</style>